/**
 * Référentiel pays (ISO 3166-1 alpha-3 + nom FR) — partagé par le wizard de
 * création INPI (99.98) : nationalité (`codeNationalite` ISO3) et pays de
 * naissance (`paysNaissance` texte). Donnée de référence statique.
 *
 * `eu: true` marque les membres UE/EEE (+ Suisse, assimilée pour la liberté
 * d'établissement) : la branche « Autre — UE/EEE » du sélecteur de nationalité
 * est filtrée dessus.
 *
 * Liste large mais non exhaustive : un prospect dont le pays n'est pas listé
 * choisit « Autre / non listée » (valeur vide) — le conseiller complète au
 * dépôt (jamais de blocage du parcours).
 */
export const COUNTRIES = [
  // UE / EEE (+ Suisse)
  { iso3: "FRA", name: "France", eu: true },
  { iso3: "DEU", name: "Allemagne", eu: true },
  { iso3: "AUT", name: "Autriche", eu: true },
  { iso3: "BEL", name: "Belgique", eu: true },
  { iso3: "BGR", name: "Bulgarie", eu: true },
  { iso3: "CYP", name: "Chypre", eu: true },
  { iso3: "HRV", name: "Croatie", eu: true },
  { iso3: "DNK", name: "Danemark", eu: true },
  { iso3: "ESP", name: "Espagne", eu: true },
  { iso3: "EST", name: "Estonie", eu: true },
  { iso3: "FIN", name: "Finlande", eu: true },
  { iso3: "GRC", name: "Grèce", eu: true },
  { iso3: "HUN", name: "Hongrie", eu: true },
  { iso3: "IRL", name: "Irlande", eu: true },
  { iso3: "ISL", name: "Islande", eu: true },
  { iso3: "ITA", name: "Italie", eu: true },
  { iso3: "LVA", name: "Lettonie", eu: true },
  { iso3: "LIE", name: "Liechtenstein", eu: true },
  { iso3: "LTU", name: "Lituanie", eu: true },
  { iso3: "LUX", name: "Luxembourg", eu: true },
  { iso3: "MLT", name: "Malte", eu: true },
  { iso3: "NOR", name: "Norvège", eu: true },
  { iso3: "NLD", name: "Pays-Bas", eu: true },
  { iso3: "POL", name: "Pologne", eu: true },
  { iso3: "PRT", name: "Portugal", eu: true },
  { iso3: "CZE", name: "Tchéquie", eu: true },
  { iso3: "ROU", name: "Roumanie", eu: true },
  { iso3: "SVK", name: "Slovaquie", eu: true },
  { iso3: "SVN", name: "Slovénie", eu: true },
  { iso3: "SWE", name: "Suède", eu: true },
  { iso3: "CHE", name: "Suisse", eu: true },
  // Hors UE/EEE
  { iso3: "DZA", name: "Algérie", eu: false },
  { iso3: "AND", name: "Andorre", eu: false },
  { iso3: "AGO", name: "Angola", eu: false },
  { iso3: "ARG", name: "Argentine", eu: false },
  { iso3: "ARM", name: "Arménie", eu: false },
  { iso3: "AUS", name: "Australie", eu: false },
  { iso3: "AZE", name: "Azerbaïdjan", eu: false },
  { iso3: "BGD", name: "Bangladesh", eu: false },
  { iso3: "BEN", name: "Bénin", eu: false },
  { iso3: "BOL", name: "Bolivie", eu: false },
  { iso3: "BIH", name: "Bosnie-Herzégovine", eu: false },
  { iso3: "BRA", name: "Brésil", eu: false },
  { iso3: "BFA", name: "Burkina Faso", eu: false },
  { iso3: "BDI", name: "Burundi", eu: false },
  { iso3: "KHM", name: "Cambodge", eu: false },
  { iso3: "CMR", name: "Cameroun", eu: false },
  { iso3: "CAN", name: "Canada", eu: false },
  { iso3: "CHL", name: "Chili", eu: false },
  { iso3: "CHN", name: "Chine", eu: false },
  { iso3: "COL", name: "Colombie", eu: false },
  { iso3: "COM", name: "Comores", eu: false },
  { iso3: "COG", name: "Congo", eu: false },
  { iso3: "COD", name: "Congo (RDC)", eu: false },
  { iso3: "KOR", name: "Corée du Sud", eu: false },
  { iso3: "CIV", name: "Côte d'Ivoire", eu: false },
  { iso3: "CUB", name: "Cuba", eu: false },
  { iso3: "DJI", name: "Djibouti", eu: false },
  { iso3: "EGY", name: "Égypte", eu: false },
  { iso3: "ARE", name: "Émirats arabes unis", eu: false },
  { iso3: "ECU", name: "Équateur", eu: false },
  { iso3: "USA", name: "États-Unis", eu: false },
  { iso3: "ETH", name: "Éthiopie", eu: false },
  { iso3: "GAB", name: "Gabon", eu: false },
  { iso3: "GMB", name: "Gambie", eu: false },
  { iso3: "GEO", name: "Géorgie", eu: false },
  { iso3: "GHA", name: "Ghana", eu: false },
  { iso3: "GIN", name: "Guinée", eu: false },
  { iso3: "GNB", name: "Guinée-Bissau", eu: false },
  { iso3: "GNQ", name: "Guinée équatoriale", eu: false },
  { iso3: "HTI", name: "Haïti", eu: false },
  { iso3: "IND", name: "Inde", eu: false },
  { iso3: "IDN", name: "Indonésie", eu: false },
  { iso3: "IRN", name: "Iran", eu: false },
  { iso3: "IRQ", name: "Irak", eu: false },
  { iso3: "ISR", name: "Israël", eu: false },
  { iso3: "JPN", name: "Japon", eu: false },
  { iso3: "JOR", name: "Jordanie", eu: false },
  { iso3: "KAZ", name: "Kazakhstan", eu: false },
  { iso3: "KEN", name: "Kenya", eu: false },
  { iso3: "XKX", name: "Kosovo", eu: false },
  { iso3: "LBN", name: "Liban", eu: false },
  { iso3: "LBY", name: "Libye", eu: false },
  { iso3: "MDG", name: "Madagascar", eu: false },
  { iso3: "MYS", name: "Malaisie", eu: false },
  { iso3: "MLI", name: "Mali", eu: false },
  { iso3: "MAR", name: "Maroc", eu: false },
  { iso3: "MUS", name: "Maurice", eu: false },
  { iso3: "MRT", name: "Mauritanie", eu: false },
  { iso3: "MEX", name: "Mexique", eu: false },
  { iso3: "MDA", name: "Moldavie", eu: false },
  { iso3: "MCO", name: "Monaco", eu: false },
  { iso3: "MNG", name: "Mongolie", eu: false },
  { iso3: "MNE", name: "Monténégro", eu: false },
  { iso3: "MOZ", name: "Mozambique", eu: false },
  { iso3: "NPL", name: "Népal", eu: false },
  { iso3: "NER", name: "Niger", eu: false },
  { iso3: "NGA", name: "Nigéria", eu: false },
  { iso3: "MKD", name: "Macédoine du Nord", eu: false },
  { iso3: "NZL", name: "Nouvelle-Zélande", eu: false },
  { iso3: "PAK", name: "Pakistan", eu: false },
  { iso3: "PSE", name: "Palestine", eu: false },
  { iso3: "PAN", name: "Panama", eu: false },
  { iso3: "PRY", name: "Paraguay", eu: false },
  { iso3: "PER", name: "Pérou", eu: false },
  { iso3: "PHL", name: "Philippines", eu: false },
  { iso3: "QAT", name: "Qatar", eu: false },
  { iso3: "DOM", name: "République dominicaine", eu: false },
  { iso3: "RUS", name: "Russie", eu: false },
  { iso3: "RWA", name: "Rwanda", eu: false },
  { iso3: "SEN", name: "Sénégal", eu: false },
  { iso3: "SRB", name: "Serbie", eu: false },
  { iso3: "SLE", name: "Sierra Leone", eu: false },
  { iso3: "SGP", name: "Singapour", eu: false },
  { iso3: "SOM", name: "Somalie", eu: false },
  { iso3: "SDN", name: "Soudan", eu: false },
  { iso3: "LKA", name: "Sri Lanka", eu: false },
  { iso3: "SYR", name: "Syrie", eu: false },
  { iso3: "TWN", name: "Taïwan", eu: false },
  { iso3: "TZA", name: "Tanzanie", eu: false },
  { iso3: "TCD", name: "Tchad", eu: false },
  { iso3: "THA", name: "Thaïlande", eu: false },
  { iso3: "TGO", name: "Togo", eu: false },
  { iso3: "TUN", name: "Tunisie", eu: false },
  { iso3: "TUR", name: "Turquie", eu: false },
  { iso3: "UKR", name: "Ukraine", eu: false },
  { iso3: "URY", name: "Uruguay", eu: false },
  { iso3: "VEN", name: "Venezuela", eu: false },
  { iso3: "VNM", name: "Vietnam", eu: false },
  { iso3: "YEM", name: "Yémen", eu: false },
  { iso3: "ZMB", name: "Zambie", eu: false },
  { iso3: "ZWE", name: "Zimbabwe", eu: false },
  { iso3: "GBR", name: "Royaume-Uni", eu: false },
];

/** Membres UE/EEE (+ Suisse) — branche « Autre — UE/EEE » du sélecteur. */
export const EU_EEA_COUNTRIES = COUNTRIES.filter((c) => c.eu);

/** Nom FR d'un pays depuis son code ISO3 (`null` si inconnu). */
export function countryNameByIso3(iso3) {
  const match = COUNTRIES.find((c) => c.iso3 === iso3);
  return match ? match.name : null;
}
